<template >
  <v-container :class="['mx-0']" fluid>

    <v-row>

        <v-col :cols="cols">
        <collection-list />
        </v-col>


        <v-col :cols="12-cols">

        <CollectionDetail
        v-if="showCollection"/>

        </v-col>

    </v-row>

    <snackbar-message message="Upload successful! The collection take 1-5 minutes to generate; we'll let you know when it's ready." @closeSnackbar="clearUploadSuccess" :show="uploadSuccess"
    />
    <li v-for="col in justGenerated" >

        <snackbar-message :message="message(col)"
        :show="justGenerated.includes(col)"
        @closeSnackbar="() => cutFromJustGenerated(col)"
        :extra="true" :id="col[0]" />
    </li>
    <snackbar-message :message="errorMessage" :show="showError" color="error" @closeSnackbar ="()=> hideError()">

    </snackbar-message>

  </v-container>
</template>

<script>
// @ is an alias to /src
// import CusipSearchBox from '@/components/CusipSearchBox.vue'
// import CusipSearchResults from '@/components/CusipSearchResults.vue'
import CollectionDetail from '@/components/CollectionDetail.vue'
import CollectionList from '@/components/CollectionList.vue'
import CollectionInfo from '@/components/CollectionInfo.vue'
import {mapState} from 'vuex'
import { startFileGeneration, getCollections, getCollectionItems, getCollection, deleteCollection, renameCollection} from '@/utils/collections'
import SnackbarMessage from '@/components/SnackbarMessage.vue'
import {get, set} from '@/utils/utils'


export default {
  name: 'Collections',
  components: {
    CollectionList,
    CollectionInfo,
    CollectionDetail,
    SnackbarMessage

  },
  data(){
    return {
        showError: false,
        errorMessage: ''
    }
  },
  computed: {
    cols(){
        let smallNames = ['xs', 'sm'];
        let medNames = ['md', 'lg']
        let breakpoint = this.$vuetify.breakpoint.name
        if(smallNames.includes(breakpoint)){
        return 6;}
        else if(medNames.includes(breakpoint)){
            return  5}
        else{
                return 4
            }
    },
    showCollection(){
      return this.collectionId
    },
    ...mapState({
        collection: 'collection',
        collections: 'collections',
        collectionItems: 'collectionItems',
        collectionId: 'collectionId',
        collectionListRefreshedAt: 'collectionListRefreshedAt',
        collectionScope: 'collectionScope',
        colToGenerate: 'colToGenerate',
        uploadSuccess: 'uploadSuccess',
        startGenerationCheck: 'startGenerationCheck',
        justGenerated: 'justGenerated'
        })
  },

//remove scrollbar from /collections body
//without removing it from any other page
//rule for body.no-scroll is in global.css
      beforeCreate: function() {

        document.body.className = 'no-scroll';
    },

  methods: {
    getCollections(){
        getCollections(this.collectionScope).
        then(res => {
            if(res.data.length === 0){
                if(this.collectionScope === 'mine') {
                    this.$store.dispatch('updateState', ['noMyCollections', true])
                }
                else {
                    this.$store.dispatch('updateState', ['noSharedCollections', true])
                }
            }
            else {
                if(this.collectionScope === 'mine') {
                    this.$store.dispatch('updateState', ['noMyCollections', false])
                }
                else {
                    this.$store.dispatch('updateState', ['noSharedCollections', false])
                }
            }
            this.collectionScope === 'mine'?
            this.$store.dispatch('updateState', ['myCollections', res.data]): this.$store.dispatch('updateState', ['sharedCollections', res.data])
            // this.$store.dispatch('updateState', ['collectionListRefreshedAt', Date.now()]);

        }
        )
    },
    getCollectionItems(col){
        getCollectionItems(col).then(res =>
            {
                this.$store.dispatch('updateState', [
                    'collectionItems', res.data
                ]);

            }
        )
    },
    getCollection(id){
            getCollection(id)
            .then(res => {

                this.$store.dispatch('updateState',[
                    'collection', res.data
                ]);

            })
    },
    fetchData(){
          this.$store.dispatch('updateState', ['collectionId', this.$route.params.collection_id]);

         this.getCollections(this.collectionScope);
        if(this.collectionId){
            this.getCollectionItems({id: this.collectionId});
            this.getCollection(this.collectionId)
        }
     },
     clearUploadSuccess(){
        this.$store.dispatch('updateState', ['uploadSuccess', false]);
        this.fetchData();
     },
      cutFromJustGenerated(item){

        let justGenerated = this.justGenerated.filter(x=> x[0]!=item[0]);

        this.$store.dispatch('updateState', ['justGenerated', justGenerated])

     },
     hideError(){
        this.showError = false;
     },
     message(item){
        return `Collection ${item[1]} has finished generating`


     }
  },

  mounted(){
    this.fetchData();
    if(this.$route.name === 'Collections'){
    document.body.classList.add('no-scroll')
    }


    if(this.startGenerationCheck){

        this.$store.dispatch('updateState', ['startGenerationCheck', false])}

    //set('colsToGenerate',[])


    // console.log('mounted sees', get('colsToGenerate'))
    if(get('colsToGenerate')){

        get('colsToGenerate').forEach(col =>
        {

            let count = 0


            //every 20 seconds, check if collection is generated yet
             let interval =
                window.setInterval(() => {

                    if(count<20){

                getCollection(col).then(res=> {
                    let status =  res.data.download_generation_status

                if(status==='Error'){
                    this.showError = true;
                    let name = res.data.name
                    this.errorMessage = `An error has occurred while generating collection ${name}`
                    clearInterval(interval)
                }
                else if(status ==='Generated'){
                    //remove collection from colsToGenerate
                   let colsToGenerate  = get('colsToGenerate').filter(x=> x!= col);

                    set('colsToGenerate', colsToGenerate);


                    this.justGenerated.push([col, res.data.name]);
                    this.$store.dispatch('updateState',['justGenerated', this.justGenerated] )

                    clearInterval(interval)

                }
                else if(!status){
                    count++

                }


                })
                .catch(err => {
                    console.log(err);
                clearInterval(interval)
             })
             }

             // if download_generation_status is null for 20 runs of interval
             //(i.e. after 200 seconds)
             //give up and clear interval
             else{
                 clearInterval(interval)
             }
             }, 20000

             )





        }
        )

    }


  },


  beforeDestroy(){
    document.body.classList.remove('no-scroll')
  },
  watch:{$route(to, from){


    this.fetchData();
  },
  collectionScope(newVal){
    this.getCollections(newVal)
  },
  colToGenerate(col){

    if(this.colToGenerate){


    //put just uploaded collection into sessionstorage in case of a refresh


            if(get('colsToGenerate') && !get('colsToGenerate').includes(col)){
                let colsToGenerate = get('colsToGenerate')
                colsToGenerate.push(col);
                set("colsToGenerate", colsToGenerate);
            }
            else{
            set('colsToGenerate', [col]);

            }


//then clear colToGenerate
             this.$store.dispatch('updateState', ['colToGenerate', ''])

            let count = 0

            //every 20 seconds, check if collection is generated yet
             let interval =
                window.setInterval(() => {

                    if(count<20){

                getCollection(col).then(res=> {
                    let status =  res.data.download_generation_status


                if(status ==='Generated'){
                    //remove collection from colsToGenerate
                   let colsToGenerate = get('colsToGenerate').filter(x=> x!= col);

                    set('colsToGenerate', colsToGenerate);

                    // console.log('after generation of', col, get('colsToGenerate'))

                    this.justGenerated.push([col, res.data.name]);
                    this.$store.dispatch('updateState',['justGenerated', this.justGenerated] )
                    clearInterval(interval)
                    //this.justGenerated = col;
                    //refresh page so generated collection appears
                    // window.setTimeout(() => location.reload(), 1000)
                }
                  if(status==='Error'){
                    this.showError = true;
                    let name = res.data.name
                    this.errorMessage = `An error has occurred while generating collection ${name}`
                    clearInterval(interval)
                }
                if(!status){
                    count++

                }


                })
                .catch(err => {
                    console.log(err);
                clearInterval(interval)
             })
             }

             // if download_generation_status is null for 20 runs of interval
             //(i.e. after 400 seconds)
             //give up and clear interval
             else{
                 clearInterval(interval)
             }
             }, 20000

             )







                 }
    }
  ,
  collectionListRefreshedAt: function(newVal) {

    this.fetchData()


  }
  }


}
</script>

<style scoped>
*{

    overflow-y: hidden;
    max-height:100vh;
}

#flex{
    display:flex;
    flex-direction: column;
}
</style>
